import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {EnvironmentService} from "../../_services/environment.service";
import {TabsetComponent} from "ngx-bootstrap/tabs/public_api";

@Component({
  selector: 'app-contactTheAssessor',
  templateUrl: './contactTheAssessor.component.html',
  styleUrls: ['./contactTheAssessor.component.scss']
})
export class ContactTheAssessorComponent implements OnInit, AfterViewInit {
  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  id: number;

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;

  }

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id || null;
   }

  ngAfterViewInit() {
    if(this.id !== null)
      this.selectTab(this.id -1);
  }

  ngOnInit() {
  }

}
